import TextInput from 'component/base/Form/Components/TextInput';
import { Design, Intent } from 'enums';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import FormField from '../FormField';

export interface TextInputFieldProps
  extends FieldRenderProps<string, HTMLInputElement> {
  label?: string;
  placeholder?: string;
  autoFocus?: boolean;
  invalid?: boolean;
  design?: Design;
  icon?: JSX.Element | null;
  action?: JSX.Element | null;
  errorOnModify?: boolean;
}

const TextInputField = (field: TextInputFieldProps) => {
  const {
    autoFocus,
    placeholder,
    label,
    invalid = false,
    meta,
    optional = false,
    icon,
    action,
    errorOnModify = false,
  } = field;

  const hasError =
    ((meta.touched || meta.initial !== undefined) && meta.error) ||
    (errorOnModify && meta.modified && meta.error);

  const renderField = ({
    input,
    design = Design.STANDARD,
    ...props
  }: TextInputFieldProps) => {
    return (
      <TextInput
        {...input}
        placeholder={placeholder}
        intent={hasError || invalid ? Intent.DANGER : null}
        autoFocus={autoFocus}
        design={design}
        {...props}
      />
    );
  };

  return (
    <FormField
      errorOnModify={errorOnModify}
      meta={meta}
      label={label}
      optional={optional}
      icon={icon}
      action={action}
    >
      {renderField(field)}
    </FormField>
  );
};

export default TextInputField;
